import { ExternalLink } from '@signate-cloud/ui-lib/components/slims/ExternalLink';
import { signateNotifications } from 'locales/ja/signate_notifications';
import type { SignateNotificationsUnsignedInResponse } from 'apis/signate_notifications/un_signed_in';

type SignateNotificationCarouselProps = {
  signateNotificationsResource:
    | SignateNotificationsUnsignedInResponse
    | undefined;
};

export const SignateNotificationCarousel: React.FC<
  SignateNotificationCarouselProps
> = ({ signateNotificationsResource }) => {
  return (
    <>
      {signateNotificationsResource &&
        signateNotificationsResource.totalCount > 0 && (
          <div
            id="signateNotifications"
            className="carousel slide d-flex flex-column justify-content-between bg-white"
            data-ride="carousel"
            data-interval="false"
          >
            <h5 className="carousel-title">
              {signateNotifications.resourceName}
            </h5>
            {/* カルーセルのコンテンツ */}
            <div
              className="carousel-inner"
              style={{ overflowX: 'hidden', overflowY: 'auto', flexGrow: 1 }}
            >
              {signateNotificationsResource.signateNotifications.map(
                (notification, index) => (
                  <div
                    className={`carousel-item ${index === 0 ? 'active' : ''}`}
                    key={index}
                  >
                    <div className="d-flex justify-content-center w-100">
                      <div className="carousel-content-container w-100">
                        <div className="carousel-title-container">
                          <span className="carosel-title-text">
                            {notification.title}
                          </span>
                          {notification.displayKind === 'important' && (
                            <span className="carousel-title-important bg-danger ml-1">
                              重要
                            </span>
                          )}
                        </div>
                        <p className="carousel-body mb-1 text-justify">
                          {notification.body}
                        </p>
                        {notification.externalLinkUrl && (
                          <div className="carousel-body-link text-left">
                            <span className="carousel-body-link-text">
                              詳しくは
                              <ExternalLink
                                href={notification.externalLinkUrl}
                                linkText="こちら"
                                externalIconName="fa-external-link-alt"
                              />
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )
              )}
            </div>
            {signateNotificationsResource.totalCount > 1 && (
              <>
                {/* インジケーター */}
                <ol className="carousel-indicators mb-0 mg-t-5">
                  {signateNotificationsResource.signateNotifications.map(
                    (_, index) => (
                      <li
                        data-target="#signateNotifications"
                        data-slide-to={index}
                        className={`${index === 0 ? 'active' : ''}`}
                        key={index}
                      ></li>
                    )
                  )}
                </ol>
                {/* 左右の矢印 */}
                <a
                  className="carousel-control-prev"
                  href="#signateNotifications"
                  role="button"
                  data-slide="prev"
                >
                  <i className="carousel-control-prev-icon fas fa-chevron-left"></i>
                  <span className="sr-only">前へ</span>
                </a>
                <a
                  className="carousel-control-next"
                  href="#signateNotifications"
                  role="button"
                  data-slide="next"
                >
                  <i className="carousel-control-next-icon fas fa-chevron-right"></i>
                  <span className="sr-only">次へ</span>
                </a>
              </>
            )}
          </div>
        )}
      <style>
        {`
          .carousel {
            border-color: #adb5bd;
            width: 100%;
            max-width: 600px;
            height: 250px;
            max-height: 250px;
            padding-top: 20px;
            padding-bottom: 5px;
            padding-left: 10px;
            padding-right: 10px;
            margin: 0 auto 60px;
            border-radius: 4px;
            box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.3);
          }
          .carousel-title {
            color: #000;
            font-weight: 900;
            text-align: center;
            margin-bottom: 20px;
            line-height: 1;
          }
          .carousel-content-container {
            position: relative;
            right: 0;
            left: 0;
            bottom 0;
          }
          .carousel-title-container {
            line-height: 1.3;
            margin-bottom: 10px;
            padding: 0 10px;
          }
          .carosel-title-text {
            font-size: 15px;
            vertical-align: middle;
            color: #000;
            font-weight: 900;
          }
          .carousel-title-important {
            font-size: 11px;
            vertical-align: middle;
            color: #fff;
            padding: 3px 4px;
            word-break: keep-all;
          }
          .carousel-body {
            padding: 0 10px;
            color: #868ba1;
            white-space: pre-wrap;
            font-size: .875rem
          }
          .carousel-body-link {
            padding: 0 10px;
            color: #868ba1;
          }
          .carousel-body-link-text {
            font-size: .875rem
          }
          .carousel-body-link-text a {
            transition: all 0.2s ease-in-out;
          }
          .carousel-body-link-text a:hover {
            color: #115da4;
            text-decoration: none;
          }
          .carousel-indicators {
            position: relative;
            bottom: 0;
          }
          .carousel-indicators li {
            background-color: #ced4da;
            cursor: pointer;
            width: 8px;
            height: 8px;
            border-radius: 50%;
            border-top: none;
            border-bottom: none;
          }
          .carousel-indicators li.active {
            background-color: #343a40;
          }
          .carousel-control-prev {
            transition: all 0.2s ease-in-out;
            width: 12%;
            left: -70px;
            color: #6c757d;
          }
          .carousel-control-prev:focus {
              color: #6c757d;
          }
          .carousel-control-prev:hover {
            color: #212529;
          }
          .carousel-control-next {
          transition: all 0.2s ease-in-out;
          width: 12%;
            right: -70px;
            color: #6c757d;
          }
          .carousel-control-next:focus {
            color: #6c757d;
          }
          .carousel-control-next:hover {
            color: #212529;
          }
        `}
      </style>
    </>
  );
};
